import { writable } from "svelte/store";

interface EmoteCache {
    [emote: string]: string;
}

function createCache() {
    const { subscribe, update } = writable<EmoteCache>({});

    let cache: EmoteCache = {};
    subscribe((emoteCache) => {
        cache = emoteCache;
    });

    return {
        subscribe,
        isCacheSet: (key: string) => Object.keys(cache).includes(key),
        updateCache: (key: string, value: string) => {
            update((emoteCache) => {
                emoteCache[key] = value;
                return emoteCache;
            });
        },
    };
}

export const emoteGraphicCache = createCache();
export const emoteSoundCache = createCache();
